export type LogoutEventDetail = {
  message?: string;
  autoConfirm?: boolean; // true = auto click Confirm as soon as it opens
};

const EVENT_NAME = "app:force-logout";

/** Fire this from anywhere (e.g., http.ts on 401/403) */
export function openLogoutModal(detail: LogoutEventDetail = {}) {
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail }));
}

/** Internal: subscribe */
export function onOpenLogoutModal(listener: (detail: LogoutEventDetail) => void) {
  const handler = (e: Event) => {
    const ce = e as CustomEvent<LogoutEventDetail>;
    listener(ce.detail || {});
  };
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}
